/* eslint-disable camelcase */
import { MRT_ColumnDef } from 'material-react-table';
import React, { useMemo } from 'react';

import { Translate, useTranslation } from 'src/containers/i18n';

function useGetFileNameColumn<
  T extends {
    fileName?: string | null;
  },
>(): MRT_ColumnDef<T> {
  const t = useTranslation();

  return useMemo(
    () => ({
      Header: () => <Translate id="downloads.listPage.table.header.name" />,
      accessorFn: (row) => row.fileName,
      header: t('downloads.listPage.table.header.name'),
      muiTableHeadCellFilterTextFieldProps: { placeholder: t('downloads.listPage.table.header.name') },
    }),
    [t],
  );
}

export default useGetFileNameColumn;
